import React from 'react';
import { RecordView } from '../../components';
import { APIRequests } from '../../../config/api';
import { userEdit } from '../../config/layouts/user';
import { useParams } from 'react-router-dom';

export const UserEdit = () => {
  const { id } = useParams();
  const props = {
    id: id!,
    getRequest: APIRequests.UsersGet,
    updateRequest: APIRequests.UserUpdate,
    layout: userEdit,
  };
  return <RecordView {...props} />;
};
